import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
      <nav className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/857147547f7da499a0fc7d35aaf6d8ec/390d10369bbbb8f9b90e17aee7042be0.png" 
              alt="Izislide - Imagez vos idées" 
              className="h-12"
            />
            <span className="ml-3 text-sm text-gray-600 italic hidden md:inline">Imagez vos idées</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <Link 
              to="/agences" 
              className={`text-gray-700 hover:text-[#00A86B] transition-colors font-medium cursor-pointer ${isActive('/agences') ? 'text-[#00A86B]' : ''}`}
            >
              Agences
            </Link>
            <Link 
              to="/entreprises" 
              className={`text-gray-700 hover:text-[#00A86B] transition-colors font-medium cursor-pointer ${isActive('/entreprises') ? 'text-[#00A86B]' : ''}`}
            >
              Entreprises
            </Link>
            <Link 
              to="/formateurs" 
              className={`text-gray-700 hover:text-[#00A86B] transition-colors font-medium cursor-pointer ${isActive('/formateurs') ? 'text-[#00A86B]' : ''}`}
            >
              Formateurs
            </Link>
            <Link 
              to="/formations" 
              className={`text-gray-700 hover:text-[#00A86B] transition-colors font-medium cursor-pointer ${isActive('/formations') ? 'text-[#00A86B]' : ''}`}
            >
              Formations
            </Link>
            <Link 
              to="/a-propos" 
              className={`text-gray-700 hover:text-[#00A86B] transition-colors font-medium cursor-pointer ${isActive('/a-propos') ? 'text-[#00A86B]' : ''}`}
            >
              À propos
            </Link>
            <Link 
              to="/blog" 
              className={`text-gray-700 hover:text-[#00A86B] transition-colors font-medium cursor-pointer ${isActive('/blog') ? 'text-[#00A86B]' : ''}`}
            >
              Blog
            </Link>
            <Link 
              to="/contact" 
              className="bg-[#00A86B] text-white px-6 py-2 rounded-lg hover:bg-[#008f5c] transition-all font-semibold whitespace-nowrap cursor-pointer"
            >
              Contact
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="lg:hidden text-gray-700 cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
            <div className="flex flex-col space-y-4">
              <Link 
                to="/agences" 
                className="text-gray-700 hover:text-[#00A86B] transition-colors font-medium cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Agences
              </Link>
              <Link 
                to="/entreprises" 
                className="text-gray-700 hover:text-[#00A86B] transition-colors font-medium cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Entreprises
              </Link>
              <Link 
                to="/formateurs" 
                className="text-gray-700 hover:text-[#00A86B] transition-colors font-medium cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Formateurs
              </Link>
              <Link 
                to="/formations" 
                className="text-gray-700 hover:text-[#00A86B] transition-colors font-medium cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Formations
              </Link>
              <Link 
                to="/a-propos" 
                className="text-gray-700 hover:text-[#00A86B] transition-colors font-medium cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                À propos
              </Link>
              <Link 
                to="/blog" 
                className="text-gray-700 hover:text-[#00A86B] transition-colors font-medium cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Blog
              </Link>
              <Link 
                to="/contact" 
                className="bg-[#00A86B] text-white px-6 py-2 rounded-lg hover:bg-[#008f5c] transition-all font-semibold text-center whitespace-nowrap cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Contact
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}